import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { GruposService } from 'app/main/wizard-cgo/services/grupos.service';
import * as backInter from 'app/auth/auth-data.model';
import { BehaviorSubject, Observable } from 'rxjs';


export interface PeriodicElement {
  nameGrupo: string;
  descripcion: string;
  filtros: string;





}

@Component({
  selector: 'adming',
  templateUrl: './adming.component.html',
  styleUrls: ['./adming.component.scss']
})
export class AdmingComponent implements OnInit {
  gruposFocus: backInter.GruposFocusAreaAll;
  infoGrupo: backInter.infoGrupoFocusArea;



  @Output() CambioTab: EventEmitter<boolean> = new EventEmitter();
  @Output() infoGrupoFocus: EventEmitter<any> = new EventEmitter();
  @Output() EditarNom: EventEmitter<string> = new EventEmitter();
  private eventsSubscription: any
  @Input() actualizaGrupos: Observable<any>;

  ELEMENT_DATA: PeriodicElement[] = [
    {nameGrupo: 'Primer Grupo Demo', descripcion: 'Demo', filtros: 'País/Cargo y/o funcion/Antiguedad/Género'},
    {nameGrupo: 'Capacitation 2157', descripcion: 'Group to launch ...', filtros: 'Gender/Woman, Country/Mexico'},
    {nameGrupo: 'Capacitation 2158', descripcion: 'Group to launch ...', filtros: 'Dimention/Credibility'},
    {nameGrupo: 'Capacitation 2159', descripcion: 'Group to launch ...', filtros: 'Dimention/Capacity/0-65%'},

  ];
  displayedColumns: string[] = ['aplicar','nameGrupo', 'descripcion', 'filtros','accion'];
  dataSource = this.ELEMENT_DATA;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private gruposService: GruposService,
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_focus.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.getGruposFocusAll();
    this.eventsSubscription = this.actualizaGrupos.subscribe( (datos) => {
      console.log("actualiza lista adicionales en traducciones");
      this.getGruposFocusAll();
    })
  }
  eliminarGrupo(){
    Swal.fire({
      title: 'Estas Seguro de Eliminar el Grupo',
    });
    // Swal.fire({
    //   title: 'Estas Seguro de Eliminar la Encuesta',
    //   icon: 'warning',
    //   showCancelButton: true,
    //   
    //   
    //   confirmButtonText: rspSi,
    //   cancelButtonText: rspNo
    // });
    // this.mensajeSwal();

  }
  cambioTabC(){
    this.CambioTab.emit(true);
  }

  editarNombTab(numero: number){
    switch(numero){
      case 1:
      this.EditarNom.emit("Editar Grupo");
      break;
      case 2:
      this.EditarNom.emit("Crear Grupo");
      break;
    }
  }

  getGruposFocusAll(){
    let datos= {encuestaId: localStorage.getItem('encuestaID')};
    this.gruposService.getGruposFocusAll(datos).subscribe((data: backInter.GruposFocusAreaAll) => {
      console.log(data);
      this.gruposFocus= data;

    });
    }

    deleteGruposFocus(idgrupo: string){

      let texto = 'LANDINFOCUS.MODALES.DELETE';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });

      let modal = 'LANDINFOCUS.MODALES.COMDELETE';
      this.translateSrv.get(modal).subscribe((res1: string) => { modal = res1; });

      Swal.fire({
        /*title: 'Are you sure?',*/
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: 'si',
        cancelButtonText: 'no'
      }).then((result) => {
        if (result.value) {
          let datos={grupoId: idgrupo};
          console.log(datos);
          this.gruposService.deleteGruposFocus(datos).subscribe((data: any) => {
           console.log(data);
            this.getGruposFocusAll();


             Swal.fire({
               icon: 'success',
               title: modal,
               confirmButtonColor: '#e40601'
             });

         }, error => {
           console.log(error);
         });

        }
      });




    }



   infoGrupoFocusArea(idgrupo: string){

     let datos= {grupoId: idgrupo};
     this.gruposService.getInfoGrupoFocus(datos).subscribe((data: backInter.infoGrupoFocusArea) => {
       console.log(data);
      this.infoGrupo= data;
      this.infoGrupoFocus.emit(this.infoGrupo);
     });





  }


}
